import { Grid } from '@mui/material';
import { useState } from 'react';
import { Outlet } from 'react-router';

type VirtualCloud = Record<string, unknown>;

const Account = (): React.ReactElement => {
  const [virtualClouds, setVirtualClouds] = useState<VirtualCloud[] | undefined>(undefined);

  return (
    <Grid
      container
      justifyContent='space-between'
    >
      <Grid
        item
        xs={14}
      >
        <Outlet context={[virtualClouds, setVirtualClouds]} />
      </Grid>
    </Grid>
  );
};

export default Account;
